import { firestoreAction } from 'vuexfire'
import _ from 'lodash'
import { tasksCollection } from '@/firebase/data'
import {currentUserId, db} from '@/firebase/firebase'
import { timestamp } from '@/firebase/firebaseHelpers'
import { midnight, areEqual, formatyyymmdd, dateIn, addDays } from '@/helpers/date'
import * as DateHelper from '@/helpers/date'
import Routine from '@/models/Routine'
// import state from './_state'
// import mutations from './_mutations'
// import actions from './_actions'
// import getters from './_getters'


const todayTask = (task, getters) => task.deadline && areEqual(task.deadline.toDate(), getters.today)
const overdueTask = (task, getters) => task.deadline && task.deadline.toDate() < getters.today
const tomorrowTask = (task, getters) => task.deadline && areEqual(task.deadline.toDate(), getters.tomorrow)
const dayAfterTomorrowTask = (task, getters) => task.deadline && areEqual(task.deadline.toDate(), addDays(getters.tomorrow, 1))
const fromTodayTask = (task, getters, n) => task.deadline && areEqual(task.deadline.toDate(), addDays(getters.today, n))
const deadlineAfterTomorrow = (task, getters) => task.deadline && task.deadline.toDate() > addDays(getters.tomorrow, 1)
const inProgressOrDoneToday = (task, getters) => !task.done || (task.doneOn && areEqual(task.doneOn.toDate(), getters.today))

const taskDefaults = () => {
  return {
    title: '',
    subtasks: [],
    doneOn: null,
    showList: '',
    backgroundColor: '',
    deadline: null,
    readAt: null
  }
}

export default {
  state: {
    tasks: [],
    tasksDataLoaded: false
  },
  getters: {
    tasksDataLoaded: (state) => state.tasksDataLoaded,
    allTasks: (state) => state.tasks,
    templatedTasks: (state, getters) => _.filter(state.tasks, (task) => inProgressOrDoneToday(task, getters) && task.templateId),
    onlyRecentDoneTasks: (state, getters) => _.filter(state.tasks, (task) => inProgressOrDoneToday(task, getters)),
    plannerTasks: (state) => state.tasks,
    overdueTasks: (state, getters) => _.filter(state.tasks, (task) => task.deadline && task.deadline.toDate() < getters.today && inProgressOrDoneToday(task, getters)),
    todayTasks: (state, getters) => _.filter(getters.onlyRecentDoneTasks, (task) => task.deadline && areEqual(task.deadline.toDate(), getters.today)),
    tomorrowTasks: (state, getters) => _.filter(getters.onlyRecentDoneTasks, (task) => tomorrowTask(task, getters)),
    dayAfterTomorrowTasks: (state, getters) => _.filter(getters.onlyRecentDoneTasks, (task) => dayAfterTomorrowTask(task, getters)),
    fromTodayTasks3: (state, getters) => _.filter(getters.onlyRecentDoneTasks, (task) => fromTodayTask(task, getters, 3)),
    fromTodayTasks4: (state, getters) => _.filter(getters.onlyRecentDoneTasks, (task) => fromTodayTask(task, getters, 4)),
    fromTodayTasks5: (state, getters) => _.filter(getters.onlyRecentDoneTasks, (task) => fromTodayTask(task, getters, 5)),
    fromTodayTasks6: (state, getters) => _.filter(getters.onlyRecentDoneTasks, (task) => fromTodayTask(task, getters, 6)),
    soonTasks: (state, getters) => _.filter(getters.onlyRecentDoneTasks, (task) => deadlineAfterTomorrow(task, getters) || (task.showList === 'soon' && !overdueTask(task, getters) && !todayTask(task, getters) && !tomorrowTask(task, getters) && !dayAfterTomorrowTask(task, getters))),
    somedayTasks: (state, getters) => _.difference(getters.onlyRecentDoneTasks, _.concat(getters.overdueTasks, getters.todayTasks, getters.tomorrowTasks, getters.dayAfterTomorrowTasks, getters.soonTasks)),
    journeyItems: (state, getters) => (date) => {
      const tasks = _.filter(getters.allTasks, (task) => task.doneOn && areEqual(midnight(task.doneOn.toDate()), midnight(date)))
      const finishedRoutines = _.filter(getters.finishedRoutines, (routine) => areEqual(midnight(routine.finishedOn.toDate()), midnight(date)))

      const formattedDate = formatyyymmdd(midnight(date))
      const routines = _.filter(getters.allRoutines, (routine) => _.includes(routine.datesRaw, formattedDate))

      const goals = _.filter(getters.allGoals, (goal) => goal.doneOn && areEqual(midnight(goal.doneOn.toDate()), midnight(date)))

      return { tasks, routines, goals, finishedRoutines }
    },
  },
  mutations: {
    setDataLoaded (state) {
      state.tasksDataLoaded = true
    }
  },
  actions: {
    bindTasks: firestoreAction(context => {
      // context contains all original properties like commit, state, etc
      // and adds `bindFirestoreRef` and `unbindFirestoreRef`
      // we return the promise returned by `bindFirestoreRef` that will
      // resolve once data is ready
      return context.bindFirestoreRef(
        'tasks',
        tasksCollection.where('uid', '==', currentUserId()),
        { wait: true }
      ).then(() => { context.commit('setDataLoaded') })
    }),
    computeReviewData ({ getters }, { from, to }) {
      return new Promise((resolve) => {
        const fromMidnight = midnight(from)
        const toMidnight = midnight(to)

        const tasks = _.filter(getters.allTasks, (task) => task.doneOn && dateIn(task.doneOn.toDate(), fromMidnight, toMidnight))


        const countedRoutines = _.compact(_.map(getters.allRoutines, (routine) => {
          const count = Routine(routine).countDoneIn(fromMidnight, toMidnight)

          if (count > 0) {
            return { count, routine }
          }
        }))

        console.log('countedRoutines', countedRoutines)

        const goals = _.filter(getters.allGoals, (goal) => goal.doneOn && dateIn(goal.doneOn.toDate(), fromMidnight, toMidnight))


        // accomplished routines
        setTimeout(() => {
          resolve({ tasks, countedRoutines, goals })
        }, 100)
      })
    },
    computeStatsData ({ getters }, { daysRange }) {
      return new Promise((resolve) => {
        let tmpJourneyItems = []

        _.forEach(daysRange, (dayAgo) => {
          const date = DateHelper.addDays(DateHelper.midnight(), -dayAgo)

          tmpJourneyItems = _.concat(tmpJourneyItems, [{ date, ...getters.journeyItems(date) }])
        })

        //
        console.log(tmpJourneyItems)


        const colors =  _.uniq(_.flatten(_.map(tmpJourneyItems, (item) => {
          return _.concat(_.map(item.tasks, 'backgroundColor'), _.map(item.routines, 'backgroundColor'))
        })))

        console.log('colors', colors)


        const series = _.map(colors, (color) => {
          const data = _.map(tmpJourneyItems, (item) => {
            const tasks = _.filter(item.tasks, (_) => _.backgroundColor === color).length
            const routines = _.filter(item.routines, (_) => _.backgroundColor === color).length
            return tasks + routines
          })

          return {
            name: '',
            data
          }
        })

        console.log('series', series)

        setTimeout(() => { resolve({ series, colors }) }, 100)
      })
    },
    ADD_TASK (_, { task }) {
      console.info('ADD_TASK', task)

      const newtask = Object.assign(taskDefaults(), {
        uid: currentUserId(),
        createdAt: timestamp()
      }, task)

      tasksCollection.add(newtask)
    },
    async UPDATE_TASK (_, { task, updateFields }) {
      console.info('UPDATE_TASK', task, updateFields)

      // if (updateFields.hasOwnProperty('deadline') || updateFields.hasOwnProperty('showList')) {
      //   console.log('removin list index')
      //   updateFields.listIndex = null
      // }

      tasksCollection.doc(task.id).update(updateFields)
    },
    async UPDATE_TASKS_BATCH (dummy, { updates }) {
      console.info('UPDATE_TASKS_BATCH', updates)

      let batch = db.batch();

      _.each(updates, ({ task, updateFields })=> {
        batch.update(tasksCollection.doc(task.id), updateFields)
      })

      batch.commit()
    },
    async DELETE_TASK ({ commit }, { task }) {
      const data = { task: { ...task} }



      const reverse_detail = 'restore task'
      const title = task.title
      const action = 'ADD_TASK'

      console.info('DELETE_TASK', task)
      tasksCollection.doc(task.id).delete()

      commit('SET_LAST_ACTION', { action, title, reverse_detail, data, time: new Date() })
    },
  }
}
